import type { Metric } from 'web-vitals';

/**
 * Until an analytics sink is wired up, log in development and stay silent in
 * production. Swap the production branch for a beacon to whichever endpoint
 * should collect field data.
 */
const defaultReporter = (metric: Metric) => {
  if (process.env.NODE_ENV === 'production') return;

  const value = metric.name === 'CLS' ? metric.value.toFixed(3) : Math.round(metric.value);
  console.log(`[web-vitals] ${metric.name} ${value} (${metric.rating})`);
};

/**
 * Core Web Vitals reporting.
 *
 * This was CRA boilerplate invoked as `reportWebVitals()` with no argument, so
 * the guard meant the dynamic import never ran and nothing was ever measured.
 * It now always registers, with or without a caller-supplied handler.
 *
 * `onINP` replaces the old `getFID` - Interaction to Next Paint became a Core
 * Web Vital in March 2024 and FID was retired. INP is the metric this app is
 * most likely to fail, since long lists re-render on every keystroke.
 */
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  const report = onPerfEntry ?? defaultReporter;

  import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
    onCLS(report);
    onFCP(report);
    onINP(report);
    onLCP(report);
    onTTFB(report);
  });
};

export default reportWebVitals;
